import { locationHasWarning, locationIsOutsideTerritory } from '@/server-data'

export function getLocationAccuracy(location: uui.domain.client.Location, error?: boolean) {
  if (locationIsOutsideTerritory(location)) {
    return 'out-of-territory'
  }

  if (error) {
    return 'invalid-latLng'
  }

  if (locationHasWarning(location)) {
    return 'low-accuracy'
  }

  return 'ok'
}
